
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { GetServerSidePropsContext } from 'next'
import { useEffect } from 'react'

import Cookies from 'js-cookie'

import { getBrand } from 'pages/brand/[brandKey]'

import ImageComponent from 'components/image'
import Link from 'components/link'
import { BrandDetailsProps } from 'features/brand/brand-details'

import { useTranslate } from 'hooks/translation/use-translation'

import { getOverrideText } from 'utils/prospecting'

import UpIcon from '../../../../public/images/marketing/monitoring_FILL0_wght400_GRAD0_opsz24.svg'
import EarthIcon from '../../../../public/images/marketing/public_FILL0_wght400_GRAD0_opsz24.svg'
import css from './embed-widget.module.scss'

type BrandWidgetProps = {
  brandKey: string
  brand: BrandDetailsProps
}

const BrandWidget = ({ brand, brandKey }: BrandWidgetProps) => {
  const { t } = useTranslate('strapi-brand-embed-widget-')

  useEffect(() => {
    setTimeout(() => {
      // Note: As some brand already embed iframe with /en-hk
      Cookies.remove('NEXT_LOCALE')
    }, 1000)
  }, [])

  const offer1 = getOverrideText(brandKey, t('BrandEmbedWidget.BrandEmbedWidget_offer1'))
  const offer2 = t('BrandEmbedWidget.BrandEmbedWidget_offer2')

  return (
    <main className={css.container}>
      <h1>{t('BrandEmbedWidget.BrandEmbedWidget_header')}</h1>
      <div className={css.hr}></div>
      <p className={css.p1}>{t('BrandEmbedWidget.BrandEmbedWidget_text')}</p>
      <ul className={css.wrapper}>
        <li>
          <EarthIcon width="36px" height="36px" />
          <h2>{t('BrandEmbedWidget.BrandEmbedWidget_point1_title')}</h2>
          <p>{t('BrandEmbedWidget.BrandEmbedWidget_point1_desc')}</p>
        </li>
        <li>
          <UpIcon width="36px" height="36px" />
          <h2>{t('BrandEmbedWidget.BrandEmbedWidget_point2_title')}</h2>
          <p>{t('BrandEmbedWidget.BrandEmbedWidget_point2_desc')}</p>
        </li>
      </ul>
      <p
        className={css.p2}
        dangerouslySetInnerHTML={{
          __html: t('BrandEmbedWidget.BrandEmbedWidget_offer_text')
            .replace('{{offer1}}', `<strong>${offer1}</strong>`)
            .replace('{{offer2}}', `<strong>${offer2}</strong>`),
        }}
      ></p>
      <Link
        href={`https://lp.markato.com/referral-2?brandId=${brandKey}`}
        target="_blank"
        className={css.button}
        trackName="cta_brand_widget"
      >
        {t('BrandEmbedWidget.BrandEmbedWidget_cta')}
      </Link>
      <ImageComponent src="/images/about-us/separator.png" alt="" className={css.separator} width={120} height={16} />
    </main>
  )
}

export function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking',
  }
}

 const _getStaticProps = async (context: GetServerSidePropsContext) => {
  const locale = context.locale?.toLocaleLowerCase() ?? 'en-hk'
  const params = context.params
  const brandKey = params?.brandKey

  const brand = await getBrand(brandKey as string, locale)

  if (!brand?.brandName) {
    return {
      notFound: true,
      revalidate: 1,
    }
  }

  return {
    props: { brand, brandKey },
    revalidate: 60,
  }
}

export default BrandWidget


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/brand/embed-widget/[brandKey]/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  